import { useEffect, useState } from 'react';

type Props = {
  activeId?: string;
  isDisabled: boolean;
  isReadOnly: boolean;
  isRequired: boolean;
  labelId?: string;
  title?: string;
};

type AriaOptions = {
  'aria-activedescendant'?: string | null;
  'aria-disabled'?: boolean;
  'aria-required'?: boolean;
  'aria-readonly'?: boolean;
  'aria-labelledby'?: string;
  'aria-label'?: string;
};

export function useAriaSelectProps({
  activeId,
  isDisabled,
  isRequired,
  isReadOnly,
  labelId,
  title,
}: Props) {
  const [ariaProps, setAriaProps] = useState({});

  useEffect(() => {
    const ariaOptions: AriaOptions = {
      'aria-activedescendant': activeId || null,
      'aria-disabled': isDisabled,
      'aria-required': isRequired,
      'aria-readonly': isReadOnly,
    };
    if (labelId) {
      // warnings are thrown if a falsy value is used with `aria-labeledby`
      ariaOptions['aria-labelledby'] = labelId;
    } else {
      ariaOptions['aria-label'] = title;
    }
    setAriaProps(ariaOptions);
  }, [activeId, isDisabled, isReadOnly, isRequired, labelId, title]);

  return ariaProps;
}
